import { __ } from "@wordpress/i18n";
import Hint from '../components/Hint/Hint';
import { useMenu } from "../contexts/MenuContext";
import withForm from '../layouts/withForm';
const GEORestrictionsMaxMind = ({handleChange}) => {

    const {
        settingData
    } = useMenu();  
    return (
        <>
			{/* {console.log(blockedCountries)} */}
            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("MaxMind", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Select countries from which access will be blocked", "ultimate-security")}</p>
                        </div>
                    </div>
                    
                </div>
            </div>
			<div className="setting-unit pb-lg mb-lg">
				<div className="row">
					<div className="col-lg-5">
						<div className="title-group">
							<h5 className="pl-heading-1 fw-600 text-text">{__("MaxMind License Key", "ultimate-security")}</h5>
						</div>
					</div>
					<div className="col-lg-7">
						<div className="row justify-content-between">
							<div className="col-lg-10">
								<div className="title-group d-flex align-items-center">
									<Hint position="top" content={__("No Hints", "ultimate-security")}/>
									<input 
										type="password"
										className="form-control"
										value={settingData?.restrictions?.maxmind?.license_key}
										onChange={(e)=> handleChange('restrictions.maxmind.license_key', e.target.value)}
									/>
								</div>								
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="setting-unit pb-lg mb-lg">
				<div className="row">
					<div className="col-lg-5">
						<div className="title-group">
							<h5 className="pl-heading-1 fw-600 text-text">{__("Database File Path", "ultimate-security")}</h5>
						</div>
					</div>
					<div className="col-lg-7">
						<div className="row justify-content-between">
							<div className="col-lg-10">
								<div className="title-group d-flex align-items-center">
									<Hint position="top" content={__("No Hints", "ultimate-security")}/>
									
									{/* <div className="form-control-plaintext">{settingData?.restrictions?.maxmind?.file_path}</div> */}
									<input 
										type="text"
										className="form-control"
										value={`${ultimate_security_ajax_obj.abspath}wp-content/uploads/ultimate_security/GeoLite2-Country.mmdb`}
										// onChange={(e)=> handleChange('restrictions.maxmind.file_path', e.target.value)}
										disabled={true}
										readOnly={true}
									/>
								</div>								
							</div>
						</div>
					</div>
				</div>
			</div>
        </>
    )
}
export default withForm(GEORestrictionsMaxMind, 'restrictions.maxmind');